<mat-form-field>
  <mat-select
    [(ngModel)]="flatArea.coverage"
    placeholder="{{'FLAT.AREA.COVERAGE' | translate}}">
    <mat-option *ngFor="let type of coverageTypes" [value]="type">
      {{type}}
    </mat-option>
  </mat-select>
</mat-form-field>
